import { useEffect, useRef } from "react";

import { TextInput } from "@mantine/core";

export const TextPropertyField = (props: {
  value: string;
  defaultValue: string;
  hasValue: boolean;
  onChange: (value: string | null) => void;
}) => {
  const { value, defaultValue, hasValue, onChange } = props;
  const ref = useRef<HTMLInputElement>(null);

  const valueAsString = hasValue ? value : "";

  useEffect(() => {
    if (ref.current == null) return;
    const inputValue = ref.current.value;

    if (inputValue !== valueAsString) {
      ref.current.value = valueAsString;
    }
  }, [value]);

  return (
    <TextInput
      ref={ref}
      size="xs"
      // value={value}
      defaultValue={value}
      placeholder={defaultValue}
      // onChange={(event) => {
      //   // onChange(event.target.value);
      // }}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          event.stopPropagation();
          console.log("Enter key pressed", event);
          onChange(event.currentTarget.value);
          // onChange(event.target.value);
        }
      }}
      styles={{
        input: {
          padding: "0 8px",
          height: "40px",
          margin: 0,
        },
      }}
    />
  );
};
